export default {
    wrapper: theme => ({
        padding: theme.layout.baseline,
        paddingBottom: theme.layout.baseline / 2,
        maxWidth: theme.layout.baseline * 45,
        [theme.helpers.mq('l')]: {
            padding: theme.layout.baseline * 1.5,
            paddingBottom: theme.layout.baseline
        }
    }),
    header: theme => ({
        display: 'flex',
        flexDirection: 'column-reverse',
        alignItems: 'flex-start',
        marginTop: theme.layout.baseline,
        '&:first-of-type': {
            marginTop: '0'
        },
        [theme.helpers.mq('s')]: {
            flexDirection: 'row'
        }
    }),
    propertyRow: theme => ({
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        [theme.helpers.mq('s')]: {
            flexDirection: 'row'
        }
    }),
    property: theme => ({
        width: '100%',
        paddingRight: theme.layout.baseline / 2,
        marginTop: 0,
        marginBottom: theme.layout.baseline,
        '&:last-of-type': {
            marginBottom: theme.layout.baseline / 2
        },
        [theme.helpers.mq('s')]: {
            marginBottom: 0,
            paddingRight: theme.layout.baseline,
            width: 'auto',
            flexGrow: 1,
            flexShrink: 1,
            '&:first-of-type': {
                flexGrow: 0,
                flexShrink: 0,
                flexBasis: theme.layout.tableColumnWidths.medium
            }
        }
    }),
    spaces: theme => ({
        marginTop: theme.layout.baseline,
        marginBottom: theme.layout.baseline * 0.75
    }),
    content: ({ visible }) => theme => ({
        width: 'calc(100% + 8px)',
        padding: 4,
        margin: -4,
        ...theme.styles.revealableContent({ visible })
    }),
    meta: theme => ({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        width: '100%',
        marginBottom: theme.layout.baseline / 2,
        [theme.helpers.mq('s')]: {
            width: 'auto',
            marginBottom: 0,
            marginLeft: 0
        }
    }),
    arrow: ({ rotated }) => theme => ({
        marginLeft: theme.layout.baseline / 2,
        ...theme.styles.rotatable({ rotated })
    }),
    buttonContainer: theme => ({
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: theme.layout.baseline / 2
    }),
    actionButton: theme => ({
        flexGrow: 1,
        marginLeft: theme.layout.baseline,
        '&:first-of-type': {
            marginLeft: 0
        },
        [theme.helpers.mq('s')]: {
            flexGrow: 'inherit'
        }
    })
};
